/* Keep the photographed garment color separate from a neutral cotton weave. */
(() => {
 const script=document.currentScript, selector='.card-swatch:not(.is-unmapped),.quick-add-swatch,.pdp-swatch:not(.is-unmapped),.surprise-option-swatch,.cp-filter-value > .rounded-full:not(.is-unmapped)';
 let colors={};
 const key=value=>String(value||'').trim().toLowerCase().replace(/[\s_]+/g,'-');
 function apply(el) {
  const color=el.dataset.color||el.dataset.value||el.dataset.optionValue||el.closest('.surprise-option-choice')?.querySelector('input')?.value||el.closest('.cp-filter-value')?.querySelector('input')?.value;
  let handle=el.dataset.swatchHandle||el.closest('surprise-picker')?.dataset.productHandle;
  if (!handle && el.dataset.productUrl) handle=el.dataset.productUrl.split('/products/')[1]?.split(/[.?]/)[0];
  if (!handle && el.classList.contains('pdp-swatch')) handle=location.pathname.split('/products/')[1]?.split('/')[0];
  const hex=key(color)==='white'?'#fafafa':colors[handle]?.[key(color)];
  if (hex) {
   if (el.classList.contains('pdp-swatch')) el.style.setProperty('--swatch-hex',hex);
   else if (el.classList.contains('surprise-option-swatch')) el.style.setProperty('--swatch',hex);
   else el.style.backgroundColor=hex;
  }
  el.classList.toggle('is-white-fabric',key(color)==='white');
  if (!el.classList.contains('swatch-textured')) {
   el.classList.add('swatch-textured');
   const weave=document.createElement('span');weave.className='cotton-weave';weave.setAttribute('aria-hidden','true');el.append(weave);
  }
 }
 function scan(root=document) { if(root.nodeType!==1&&root!==document)return; if(root.matches?.(selector))apply(root);root.querySelectorAll(selector).forEach(apply); }
 scan();
 new MutationObserver(records=>records.forEach(r=>r.addedNodes.forEach(scan))).observe(document.body,{childList:true,subtree:true});
 if(script?.dataset.colors) fetch(script.dataset.colors).then(r=>{if(!r.ok)throw Error();return r.json();}).then(data=>{colors=data;scan();}).catch(()=>{});
})();
